import React from "react";
import { cn } from "@/lib/utils";

interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

const FormTextarea = React.forwardRef<HTMLTextAreaElement, FormTextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "w-full bg-white rounded-md border border-edge-input resize-none py-1.5 px-2 text-sm focus:outline-none focus:ring-2 focus:ring-sage focus:border-sage",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
FormTextarea.displayName = "FormTextarea";

export { FormTextarea };
export type { FormTextareaProps };